module.exports = __webpack_public_path__ + "img/inventory.1f9a200f.svg";